import { extractErrorMessageStrings } from '../utils/pipes';
import { getApi, postApi } from './ apiService';

const zenworkUrl = 'api/client/zenworks/v1';
export const zenworksServiceApi = {
  zenworkUrl: 'api/client/zenworks/v1',
  loginWithAppKey: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/login`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  login: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/signIn`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  ssoLogin: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/signIn/ssoSignIn`;
      const result = await postApi(requestBody, apiUrl);
      // const result = await response.json();

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  signUp: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/tax2290/signUp`;
      const result = await postApi({...requestBody, source : 'ez2290ai'}, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
        if (result.errors && Array.isArray(result.errors) && result.errors.length > 0) {
          result.message = result.errors[0].message;
        }
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  checkExist: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/signUp/CheckExist`;
      const result = await postApi(requestBody, apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  checkUser: async (email: any) => {
    try {
      const apiUrl = `${zenworkUrl}/tax2290/checkUser`;
      const result = await postApi({ ...email, source: 'ez2290ai' }, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
        if (result.errors && result.errors.length > 0) {
          result.message = result.errors[0].message;
        }
      }
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getTaxYears: async () => {
    try {
      const apiUrl = `${zenworkUrl}/General/GetTaxYears`;
      const result = await getApi(apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getSavedAddress: async () => {
    try {
      const apiUrl = `${zenworkUrl}/payment/getSavedAddress`;
      const result = await getApi(apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getState: async () => {
    try {
      const apiUrl = `${zenworkUrl}/General/GetStates`;
      const result = await getApi(apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getCountry: async () => {
    try {
      const apiUrl = `${zenworkUrl}/General/GetCountries`;
      const result = await getApi(apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getSubmissions: async () => {
    try {
      const apiUrl = `${zenworkUrl}/general/getSubmissions`;
      const result = await getApi(apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getPricingCalculator: async (requestBody: any) => {
    const appKey = localStorage.getItem('appKey');
    const reqHeaders = { Authorization: `Bearer ${appKey}` };
    try {
      const apiUrl = `${zenworkUrl}/common/getPricingCalculator`;
      const result = await postApi(requestBody, apiUrl, reqHeaders);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getWeight: async () => {
    try {
      const apiUrl = `${zenworkUrl}/tax2290/form2290/getWeight`;
      const result = await getApi(apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
        if (result.errors && result.errors.length > 0) {
          result.message = result.errors[0].message;
        }
      }
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  calculateTax2290: async (requestBody: {
    email: string;
    month: number;
    logging: string;
    weight: number | string;
  }) => {
    try {
      const apiUrl = `${zenworkUrl}/Account/calculateTaxAmount`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  salesforceLogin: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/salesforce/auth`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  createCase: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/salesforce/createCase`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  submitFeedback: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/common/submitFeedback`;
      const result = await postApi(requestBody, apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  ping: async () => {
    try {
      const apiUrl = `${zenworkUrl}/ping`;
      const result = await getApi(apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  validateZipCode: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/General/ValidateZipCode`;
      const result = await postApi(requestBody, apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  GetFormData: async (formId: any, year: any) => {
    try {
      const apiUrl = `${zenworkUrl}/General/GetFormData?formId=${formId}&year=${year}`;
      const result = await getApi(apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getDefaultScheduleDate: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/General/getDefaultScheduleDate`;
      const result = await postApi(requestBody, apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  produceToken: async () => {
    try {
      const apiUrl = `${zenworkUrl}/appSwitch/produceToken`;
      const result = await getApi(apiUrl);

      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '');
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  loginWithExchangeToken: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/appSwitch/loginWithExchangeToken`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      // throw new Error(`HTTP error! Status: ${error}`);
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  getSubmissionStatusFromRefNo: async (refNo: string) => {
    try {
      const apiUrl = `${zenworkUrl}/general/getSubmissionStatusFromRefNo?refNo=${refNo}`;
      const result = await getApi(apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      return { success: false, message: error.message, content: {} };
    }
  },
  upload: async (payload: any) => {
    try {
      const apiUrl = `api/client/zenworks/v1/upload/s3`;
      const result = await postApi(payload, apiUrl, {}, false);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, '') || result.message;
        if (result.errors && result.errors.length > 0) {
          result.message = result.errors[0].message;
        }
      }
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };

    }
  },
  idpResendOtp: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/idpResendOtp`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  idpVerifyOtp: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/idpValidateOtp`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        result.message = "OTP verification failed.";
      }
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  idpTFALogin: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/idpTFAValidate`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        const content = result?.content ?? {};
        result.message = extractErrorMessageStrings(content, result.message);
      }
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  idpSignUp: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/idpSignup`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        // Check if message needs transformation
        if (result.message === 'exists' || result.message === 'exist') {
          result.message = 'User already exists. Please login to continue.';
        }
      }
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  idpRefreshToken: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/refreshToken`;
      const result = await postApi(requestBody, apiUrl);
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  idpStoreAccessToken: async (requestBody: any) => {
    try {
      const apiUrl = `${zenworkUrl}/storeAccessToken`;
      const result = await postApi(requestBody, apiUrl);
      return result;
    } catch (error: any) {
      console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  checkAuth: async (connectionId: string) => {
    try {
      const apiUrl = `${zenworkUrl}/checkAuth`;
      const result = await postApi({ 'connectionId': connectionId }, apiUrl);
      return result
    } catch (error: any) {
            console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  },
  idpLogin: async (requestBody: any) => {
       try {
      const apiUrl = `${zenworkUrl}/idpSignin`;
      const result = await postApi(requestBody, apiUrl);
      if (!result.success) {
        // Check if message needs transformation
        if (result.message === 'exists' || result.message === 'exist') {
          result.message = 'User already exists. Please login to continue.';
        }
      }
      return result
    } catch (error: any) {
            console.error(`${error}`);
      return { success: false, message: error.message, content: {} };
    }
  }
};
